<template>
  <div>
    <div v-for="(p,idx2) in list" :key="idx2">
      <div>
        <p>p.selected:{{p.selected}}</p>
        <input
          type="radio"
          v-bind:id="combinetext('q','1')"
          v-bind:name="combinetext('q','1')"
          v-bind:value="p.name"
          :checked="p.selected"
        />
        <label v-bind:for="combinetext('q','1')">{{p.name}}</label>
      </div>
    </div>
  </div>
</template>

<script>
import helper from "../../../helpers/helper.js";
export default {
  name: "radiolist",
  props: ["list"],
  methods: {
    ...helper
  }
};
</script>

<style scoped lang="scss">
</style>